import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
import { Subscription } from 'rxjs';
import { AnalyticsService } from '../../analytics';
import { WordpressContentItem, WordpressContentService } from '../../core/wordpress-content.service';

@Component({
  selector: 'app-announcement-banner-component',
  templateUrl: './announcement-banner.component.html',
  standalone: false,
})
export class AnnouncementBannerComponent implements OnInit, OnDestroy {
  @Input() newVersion: boolean;
  subscriptions: Subscription[] = [];
  productAds: WordpressContentItem[];

  constructor(
    private wordpressContentService: WordpressContentService,
    private analyticsService: AnalyticsService,
    private snowplowService: ProductAnalyticsService,
  ) {}

  ngOnInit(): void {
    //Get adds and sort them randomly each time we load the component
    this.subscriptions.push(
      this.wordpressContentService.content.subscribe((ads) => {
        if (ads) {
          this.productAds = ads.sort(() => 0.5 - Math.random());
        } else {
          this.productAds = [];
        }
      }),
    );
    this.wordpressContentService.loadContent();
  }

  get slides(): WordpressContentItem[] {
    return this.productAds.length > 0 ? this.productAds : null;
  }

  slideClicked(clicked: { slide: WordpressContentItem; index: number }): void {
    event.preventDefault();
    const adId = clicked.slide.id;
    const path = clicked.slide.primaryButtonLink;
    this.analyticsService.track('BannerClicked', adId, 'position-' + clicked.index);
    this.goToLink(path);
  }

  goToLink(path: string): void {
    if (path.indexOf('http') >= 0) {
      window.open(path, '_blank');
    } else {
      window.location.assign(path);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
